import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from 'services/firebase';

export function useFirebaseAuth() {
  const [authUser, setAuthUser] = useState({
    uid: null,
    loading: true,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthUser({ uid: user.uid, loading: false });
      } else {
        setAuthUser({ uid: null, loading: false });
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return authUser;
}
